export default __webpack_public_path__ + "238cb6c322525ea20a6b809face06767.png";